import(/* webpackMode: "eager", webpackExports: ["ProductProvider"] */ "/app/apps/web/src/lib/context/product-context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/ui/components/ModelDialog/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/ui/components/ModelHeader/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/ui/components/ProductDetail/index.tsx");
